import { render, staticRenderFns } from "./UpdatePaidModal.vue?vue&type=template&id=b4983a52&"
import script from "./UpdatePaidModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePaidModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports